import { GoPrimitiveDot } from 'react-icons/go';

import { capitalize } from '../utils';

function Dots() {
  return (
    <div className="flex flex-row items-center">
      <GoPrimitiveDot />
      <GoPrimitiveDot />
      <GoPrimitiveDot />
      <GoPrimitiveDot />
    </div>
  );
}

export default function CreditCard({
  last4,
  exp,
  brand,
  logo,
  className,
  active,
  onClick,
  isDefault,
}) {
  return (
    <button
      className={`relative w-96 h-56 flex-shrink-0 rounded-half m-2 ${
        className ? className : ''
      }`}
      onClick={onClick}
    >
      {active && (
        <>
          <div className="absolute h-full w-full -translate-x-2 -translate-y-2 bg-primary rounded-half"></div>
          <div className="absolute h-full w-full translate-x-2 translate-y-2 bg-secondary rounded-half"></div>
        </>
      )}
      <div
        className={`relative h-full w-full rounded-half flex flex-col py-4 px-6 text-lg justify-between ${
          active ? 'text-white bg-background-dark' : 'bg-gray-100 text-gray-700'
        }`}
      >
        <div className="flex flex-col">
          <div className="flex flex-row justify-between items-start">
            <div>
              <h4 className="font-semibold text-2xl">Credit card</h4>
            </div>
            {isDefault && (
              <div className="bg-primary shadow-lg rounded py-0.5 px-1.5 font-semibold text-sm">
                Default
              </div>
            )}
          </div>
          <div className="flex flex-row justify-between">
            <Dots />
            <Dots />
            <Dots />
            <div className="text-2xl">
              {last4 || (
                <div className="text-lg">
                  <Dots />
                </div>
              )}
            </div>
          </div>
        </div>
        <div className="flex flex-row justify-between">
          <span>{exp}</span>
          <div className="flex space-x-4">
            <span>{capitalize(brand)}</span>
            {logo && <span>{logo}</span>}
          </div>
        </div>
      </div>
    </button>
  );
}
